import React from 'react';
import { PointsAndRankWrapper } from './styles';
import { Points } from './points';
import { Rank } from './rank';

export interface IPointAndRank {
  points: number | null;
  pointsLoading: boolean;
  rankLabel: string | null;
  rankLoading: boolean;
  proCard: boolean;
}

export const PointAndRank: React.FC<IPointAndRank> = ({
  points,
  pointsLoading,
  rankLoading,
  rankLabel,
  proCard,
}) => {
  return (
    <PointsAndRankWrapper>
      <Points loading={pointsLoading} points={points} />
      {proCard && <Rank loading={rankLoading} rankLabel={rankLabel} />}
    </PointsAndRankWrapper>
  );
};
